/**
 * Breadcrumb Module
 * Rozwijanie/zwijanie pełnej ścieżki po kliknięciu w kropki.
 * Auto-collapse po 2s od opuszczenia kursora.
 *
 * Użycie:
 *   <nav class="breadcrumb">
 *     <button class="breadcrumb__dots">...</button>
 *     <a class="breadcrumb__link breadcrumb__link--collapsible">Home</a>
 *     ...
 *     <span class="breadcrumb__current">Current page</span>
 *   </nav>
 */

(function () {
    'use strict';

    var COLLAPSE_DELAY = 2000;
    var EXPANDED_CLASS = 'breadcrumb--expanded';

    function init() {
        var breadcrumbs = document.querySelectorAll('.breadcrumb:not(.breadcrumb--back)');

        for (var i = 0; i < breadcrumbs.length; i++) {
            setupBreadcrumb(breadcrumbs[i]);
        }
    }

    function setupBreadcrumb(el) {
        var dotsBtn = el.querySelector('.breadcrumb__dots');
        if (!dotsBtn) return;

        var collapseTimer = null;

        // Kliknięcie w kropki — rozwiń ścieżkę
        dotsBtn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            el.classList.add(EXPANDED_CLASS);

            // Wyczyść istniejący timer
            if (collapseTimer) {
                clearTimeout(collapseTimer);
                collapseTimer = null;
            }
        });

        // Opuszczenie kursora — uruchom timer zwijania
        el.addEventListener('mouseleave', function () {
            if (!el.classList.contains(EXPANDED_CLASS)) return;

            collapseTimer = setTimeout(function () {
                el.classList.remove(EXPANDED_CLASS);
                collapseTimer = null;
            }, COLLAPSE_DELAY);
        });

        // Powrót kursora — anuluj timer
        el.addEventListener('mouseenter', function () {
            if (collapseTimer) {
                clearTimeout(collapseTimer);
                collapseTimer = null;
            }
        });
    }

    // Inicjalizacja po załadowaniu DOM
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
